<template>
  <div id="user-manage-employees-add">
    <ipub-model :title="params.id?'Edit Employee':'Add New Employee'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="employees-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-row :gutter="30">
          <ipub-col :span="4">
            <ipub-form-item prop="titleCode"
                            label="Title">
              <ipub-select v-model="params.titleCode"
                           placeholder="Title">
                <ipub-select-option v-for="(value, key) in title"
                                    :key="key"
                                    :value="key">
                  {{ value }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="firstName"
                            label="First Name">
              <ipub-input v-model.trim="params.firstName"
                          placeholder="First Name"></ipub-input>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="lastName"
                            label="Last Name">
              <ipub-input v-model.trim="params.lastName"
                          placeholder="Last Name"></ipub-input>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="30">
          <ipub-col :span="params.id?12:6">
            <ipub-form-item prop="email"
                            label="Username (Email)">
              <ipub-input v-model.trim="params.email"
                          :disabled="!!params.id"
                          placeholder="Username (Email)"></ipub-input>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6"
                    v-if="!params.id">
            <ipub-form-item prop="password"
                            label="Password">
              <ipub-input v-model.trim="params.password"
                          placeholder="Password"></ipub-input>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <!-- <ipub-form-item prop="departmentIdList"
                        label="Department">
          <ipub-select placeholder="Department"
                       mode="multiple"
                       :tree="true"
                       v-model="params.departmentIdList"
                       :options="departments" />
        </ipub-form-item> -->
        <ipub-form-item prop="roleIdList"
                        label="Roles">
          <ipub-select placeholder="Roles"
                       mode="multiple"
                       search
                       @blur="getRoles('')"
                       @search="getRoles"
                       v-model="params.roleIdList"
                       :options="roles">
            <ipub-select-option v-for="value in roles"
                                :key="value.id+'dialog'"
                                :value="value">
              {{value.journal&&value.journal.name}} {{value.name}}
            </ipub-select-option>
          </ipub-select>
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import user from '../../../api/user'
import role from '../../../api/role'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
        department: []
      },
      departments: [],
      roles: [],
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          roleList: []
        }
      } else {
        this.getQuery()
      }
      this.getRoles()
      this.getRules()
    }
  },
  methods: {
    async getQuery () {
      if (this.inputData.id) {
        this.params = await user.query(this.inputData.id)
        // this.params.departmentIdList = this.params.departmentList.map(item => item.id)
        this.params.roleIdList = this.params.roleList.map(item => item.id)
        this.params.roleIdList = this.params.roleIdList.filter((item => { return item }))
        this.rules.email[2].fun = null
      } else {
        this.rules.email[2].fun = this.checkEmail
      }
    },
    async getRoles (name = '') {
      this.roles = await role.get({ outSided: false, name })
    },
    async checkEmail () {
      if (!this.params.email) {
        return
      }
      const res = await user.validateEmail(this.params.email)
      return res
    },
    async confirm () {
      const flag = this.$refs['employees-add-form'].validate()
      if (flag) {
        this.params.roleIdList = this.params.roleIdList.filter((item => { return item }))
        if (this.params.id) {
          await user.edit(this.params.id, this.params)
          this.$message.success({ title: 'Success', content: 'This Employee has been Added!' })
        } else {
          await user.add(this.params)
          this.$message.success({ title: 'Success', content: 'This Employee has been saved!' })
        }
        this.$emit('confirm')
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        titleCode: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        firstName: [
          {
            required: true,
            message:
              'First Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message:
              'Last Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        email: [
          {
            required: true,
            message:
              'Email' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email'
          },
          {
            fun: this.checkEmail,
            message: `The author's mailbox already exists in the author list`
          }
        ],
        password: [
          {
            required: true,
            message:
              'Password' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 6,
            message: `Password length must not be less than 6 digits`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 digits`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols.`
          }
        ],
        // departmentIdList: [
        //   {
        //     required: true,
        //     message:
        //       'Department' +
        //       this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        roleIdList: [
          {
            required: true,
            min: 1,
            message:
              'Roles' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#user-manage-employees-add {
}
</style>
